/**
 * @owner @Appboy/operator
 */

import { createContext, useContext } from "react";

import type { BrazeCheckboxGroupContextValue } from "./types";

export const BrazeCheckboxGroupContext = createContext<BrazeCheckboxGroupContextValue | null>(null);

export const useBrazeCheckboxGroupContext = (): BrazeCheckboxGroupContextValue | null =>
  useContext(BrazeCheckboxGroupContext);

export const useIsInBrazeCheckboxGroup = (): boolean => useBrazeCheckboxGroupContext() !== null;
